export enum ModalEditTimeslotsModesEnum {
  EDITION = 'EDITION',
  DELETION = 'DELETION',
}
